import React, { Component } from 'react'
import { TeacherAndTAsComponent } from './'
import { connect } from 'react-redux';
import { SchoolInformationActions } from '../../../../../../store';
import lodashUtil from 'lodash';
import { DialogComponentUtil } from '../'
import { ElectiveTeachersAndTAsComponent } from './'
import { gradePickerUtil } from '../../../../gradePicker';
import { ConstraintsAndPreferences, CalculateUtil } from '..';
class TeacherAndTAsContainer extends Component {
	constructor(props) {
		super(props)
		let cellData = this.props.dataTableMap.get(this.props.cellCode)
		let numberOfTeachersAndTAsForSubject = undefined;
		let numberOfTeachersAndTAsForElective = undefined;

		if (cellData.elective !== undefined) {
			numberOfTeachersAndTAsForElective = {
				electiveId: cellData.elective._id,
				electiveName: cellData.elective.name,
				teachersAndTAs: []
			}
		} else {
			numberOfTeachersAndTAsForSubject = {
				subjectId: cellData.subject._id,
				subjectName: cellData.subject.name,
				subjectCode: cellData.subject.code,
				teachers: 1,
				TAs: 0,
			}
		}
		this.state = {
			keyArray: [],
			tempActiveSchool: this.props.activeSchool,
			numberOfTeachersAndTAsForSubject: numberOfTeachersAndTAsForSubject,
			numberOfTeachersAndTAsForElective: numberOfTeachersAndTAsForElective,
			totalTeachers: [],
			totalTAs: [],
			totalTeachersForSubject: 0,
			totalTAsForSubject: 0,
			elective: {},
			isElective: false,
			subject: {},
			numOfTeachersObject: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects)),
			numOfTeachersElective: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives)),
		}
	}

	componentWillMount() {
		if (this.props.dataTableMap.get(this.props.cellCode).elective !== undefined) {
			this.creatingOfteacherAndTAsObj();
			this.showExistingTeachersAndTAsForElectives();
		} else {
			this.showExistingTeachersAndTAsForSubjects();
		}

		this.getNumberOfTeachersAndTAs(this.state.subject)
		let elective = this.props.dataTableMap.get(this.props.cellCode).elective
		this.setState({ elective: elective });

	}

	creatingOfteacherAndTAsObj = () => {
		let numberOfTeachersAndTAsForElective = JSON.parse(JSON.stringify(this.state.numberOfTeachersAndTAsForElective))

		let cellDetails = this.props.dataTableMap.get(this.props.cellCode)
		if (cellDetails.numberOfTeachersAndTAsForElective !== undefined) {
			numberOfTeachersAndTAsForElective = JSON.parse(JSON.stringify(cellDetails.numberOfTeachersAndTAsForElective));
		} else {
			let noOfSubjects = [...cellDetails.elective.subjects];
			for (let i = 0; i < noOfSubjects.length; i++) {
				let tempObj = { teachers: 1, TAs: 0 };
				tempObj.subjectId = noOfSubjects[i]._id;
				tempObj.subjectName = noOfSubjects[i].name;
				tempObj.subjectCode = noOfSubjects[i].subjectCode;
				numberOfTeachersAndTAsForElective.teachersAndTAs.push(tempObj);
			}
		}
		this.setState({ numberOfTeachersAndTAsForElective: numberOfTeachersAndTAsForElective });
	}

	getNumberOfTeachersAndTAs = (subject, index) => {
		let noOfTeacher = 0;
		let noOfTAs = 0;
		let totalTeachers = [...this.state.totalTeachers];
		let totalTAs = [...this.state.totalTAs];
		let teacher = this.props.activeSchool.school_master.teachers
		let isElective = false
		let cellDetails = this.props.dataTableMap.get(this.props.cellCode);
		let gradeLevel = cellDetails.gradeLevel;
		let grade = cellDetails.grade;
		let group = cellDetails.group;
		let SubjectObj
		if (cellDetails.elective !== undefined) {
			isElective = true
			SubjectObj = subject
			this.setState({
				isElective: isElective
			})
		} else {
			isElective = false
			SubjectObj = cellDetails.subject
			this.setState({
				isElective: isElective
			})
		}

		let cellGradeDetailsLowestForm = []
		if (cellDetails.group !== undefined) {
			cellGradeDetailsLowestForm.push(`${cellDetails.grade}${cellDetails.group}`)
		} else {
			let gradeLevel = this.props.activeSchool.school_master.gradeLevels
			let gradeLevelObject = lodashUtil.find(gradeLevel, ["levelName", cellDetails.gradeLevel])
			let gradeObject = lodashUtil.find(gradeLevelObject.grades, ["gradeName", cellDetails.grade])
			for (let b = 0; b < gradeObject.groups.length; b++) {
				let groupCode = gradeObject.groups[b].groupName
				cellGradeDetailsLowestForm.push(`${cellDetails.grade}${groupCode}`)

			}
		}
		for (let i = 0; i < teacher.length; i++) {
			let assignedSubjects = teacher[i].assignedSubjects;
			let isSubjectPresent = undefined;

			if (SubjectObj !== undefined) {
				let subjectsArray = lodashUtil.filter(assignedSubjects, ['subjectName', SubjectObj.name])
				for (let a = 0; a < subjectsArray.length; a++) {
					let subObj = subjectsArray[a]
					let subGradesLowestForm = gradePickerUtil.convertingGradeDetailsToLowestFormat(subObj.gradeDetails, this.props)
					let gradeDetailsLowestForm = lodashUtil.difference(cellGradeDetailsLowestForm, subGradesLowestForm)
					if (gradeDetailsLowestForm.length === 0) {
						isSubjectPresent = subObj
						break
					}
				}

				this.setState({
					isElective: isElective
				})
			}

			if (isSubjectPresent !== undefined) {
				if (isSubjectPresent.gradeDetails.allGrades === true) {
					if (isSubjectPresent.isMainTeacher === true) {
						noOfTeacher++;
						continue;
					} else {
						noOfTAs++
						continue;
					}
				}
				else if (gradeLevel !== undefined && lodashUtil.find(isSubjectPresent.gradeDetails.gradeLevels, ["level", gradeLevel])) {
					if (isSubjectPresent.isMainTeacher === true) {
						noOfTeacher++;
						continue;
					} else {
						noOfTAs++
						continue;
					}
				}
				if (grade !== undefined && lodashUtil.find(isSubjectPresent.gradeDetails.grades, ['grade', grade])) {
					if (isSubjectPresent.isMainTeacher === true) {
						noOfTeacher++;
						continue;
					} else {
						noOfTAs++
						continue;
					}
				}

			}
		}
		totalTeachers[index] = noOfTeacher;
		totalTAs[index] = noOfTAs;
		this.setState({
			totalTeachers: totalTeachers,
			totalTeachersForSubject: noOfTeacher,
			totalTAsForSubject: noOfTAs,
			totalTAs: totalTAs
		})
	}

	showExistingTeachersAndTAsForSubjects = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let numberOfTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects
			if (numberOfTeachersAndTAsForSubjects !== undefined && numberOfTeachersAndTAsForSubjects.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < numberOfTeachersAndTAsForSubjects.length; b++) {
						if (numberOfTeachersAndTAsForSubjects[b].gradeDetails.grades[0].groups.length === 0) {
							if ((celldetails.subject && celldetails.subject._id == numberOfTeachersAndTAsForSubjects[b].subjectId)) {
								let grade = numberOfTeachersAndTAsForSubjects[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {
										let teachersAndTAsSubObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubjects[b]))
										delete teachersAndTAsSubObj.gradeDetails
										this.setState({
											numberOfTeachersAndTAsForSubject: teachersAndTAsSubObj
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < numberOfTeachersAndTAsForSubjects.length; c++) {
						if (numberOfTeachersAndTAsForSubjects[c].gradeDetails.grades[0].groups.length !== 0) {
							if ((celldetails.subject && celldetails.subject._id == numberOfTeachersAndTAsForSubjects[c].subjectId)) {
								let grades = numberOfTeachersAndTAsForSubjects[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode
									if (groupCode === celldetails.group) {
										let teachersAndTAsSubObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubjects[c]))
										delete teachersAndTAsSubObj.gradeDetails
										this.setState({
											numberOfTeachersAndTAsForSubject: teachersAndTAsSubObj
										})
									}
								}
							}
						}
					}
				}
			}
		}
	}

	showExistingTeachersAndTAsForElectives = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let numberOfTeachersAndTAsForElectives = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives
			if (numberOfTeachersAndTAsForElectives !== undefined && numberOfTeachersAndTAsForElectives.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < numberOfTeachersAndTAsForElectives.length; b++) {
						if (numberOfTeachersAndTAsForElectives[b].gradeDetails.grades[0].groups.length === 0) {
							if ((celldetails.elective && celldetails.elective._id == numberOfTeachersAndTAsForElectives[b].electiveId)) {
								let grade = numberOfTeachersAndTAsForElectives[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {
										let numberOfTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElectives[b]))
										delete numberOfTeachersAndTAsForElectiveObj.gradeDetails
										this.setState({
											numberOfTeachersAndTAsForElective: numberOfTeachersAndTAsForElectiveObj
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < numberOfTeachersAndTAsForElectives.length; c++) {
						if (numberOfTeachersAndTAsForElectives[c].gradeDetails.grades[0].groups.length !== 0) {
							if ((celldetails.elective && celldetails.elective._id == numberOfTeachersAndTAsForElectives[c].electiveId)) {
								let grades = numberOfTeachersAndTAsForElectives[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode
									if (groupCode === celldetails.group) {
										let numberOfTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElectives[c]))
										delete numberOfTeachersAndTAsForElectiveObj.gradeDetails
										this.setState({
											numberOfTeachersAndTAsForElective: numberOfTeachersAndTAsForElectiveObj
										})
									}
								}
							}
						}
					}
				}
			}
		}
	}


	handleChange = (value, name) => {
		let tempObj = this.state.numberOfTeachersAndTAsForSubject
		tempObj[name] = Number(value);
		this.setState({ numberOfTeachersAndTAsForSubject: tempObj });
	}

	handleChangeForElective = (value, name, index) => {
		let tempElectiveObj = JSON.parse(JSON.stringify(this.state.numberOfTeachersAndTAsForElective))
		tempElectiveObj.teachersAndTAs[index][name] = Number(value);
		this.setState({ numberOfTeachersAndTAsForElective: tempElectiveObj });
	}

	onClickOfSave = async () => {
		if (this.state.isElective === true) {
			this.onClickOfSaveForElectives();
		}
		else {
			this.onClickOfSaveForSubjects();
		}
	}

	attachingDataToCellForSubjects = () => {
		let numberOfTeachersAndTAsForSubjects = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < numberOfTeachersAndTAsForSubjects.length; i++) {
			let grades = numberOfTeachersAndTAsForSubjects[i].gradeDetails.grades[0];
			//Attach data to GRADES
			if (this.props.filter.showSections === false) {
				if (grades.groups.length === 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == numberOfTeachersAndTAsForSubjects[i].subjectId)) {
							if (value.grade === grades.grade) {
								value.numberOfTeachersAndTAsForSubject = numberOfTeachersAndTAsForSubjects[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			}
			// Attach data to GROUPS
			else {
				if (grades.groups.length !== 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == numberOfTeachersAndTAsForSubjects[i].subjectId)) {
							if (value.grade === grades.grade) {
								if (value.group === grades.groups[0].groupCode) {
									value.numberOfTeachersAndTAsForSubject = numberOfTeachersAndTAsForSubjects[i];
									dataTableMap.set(key, value);
									break;
								}
							}
						}
					}
				}
			}
		}
	}

	attachingDataToCellForElective = () => {
		let numberOfTeachersAndTAsForElectives = [...this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives];
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < numberOfTeachersAndTAsForElectives.length; i++) {
			let grades = numberOfTeachersAndTAsForElectives[i].gradeDetails.grades[0];

			//Attach data to GRADES
			if (this.props.filter.showSections === false) {
				if (grades.groups.length === 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.elective && value.elective._id == numberOfTeachersAndTAsForElectives[i].electiveId)) {
							if (value.grade === grades.grade) {
								value.numberOfTeachersAndTAsForElective = numberOfTeachersAndTAsForElectives[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			}
			// Attach data to GROUPS
			else {
				if (grades.groups.length !== 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.elective && value.elective._id == numberOfTeachersAndTAsForElectives[i].electiveId)) {
							if (value.grade === grades.grade) {
								if (value.group === grades.groups[0].groupCode) {
									value.numberOfTeachersAndTAsForElective = numberOfTeachersAndTAsForElectives[i];
									dataTableMap.set(key, value);
									break;
								}
							}
						}
					}
				}
			}
		}
	}

	onClickOfSaveForSubjects = async () => {
		let tempActiveSchool = this.state.tempActiveSchool;
		let keys = this.props.keys;
		let cellDetails = undefined;
		let gradeLevels = this.props.activeSchool.school_master.gradeLevels
		let objMatching = false;
		let templetObjForCreatingNewObj = undefined;
		let numberOfTeachersAndTAsForSubjects = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects
		let numberOfTeachersAndTAsForSubject = JSON.parse(JSON.stringify(this.state.numberOfTeachersAndTAsForSubject));
		numberOfTeachersAndTAsForSubject.showNumberOfTeachersForSubjectString = numberOfTeachersAndTAsForSubject.teachers.toString()
		numberOfTeachersAndTAsForSubject.showNumberOfTAsForSubjectString = numberOfTeachersAndTAsForSubject.TAs.toString()

		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			tempActiveSchool.schedule_constraints = [
				{ numberOfTeachersAndTAsForSubjects: [] }
			]
		}
		//KEYS 
		for (let c = 0; c < keys.length; c++) {
			cellDetails = this.props.dataTableMap.get(keys[c]);
			// gradeDetails from subject or elective 
			let cellGradeDetails = undefined;
			if (cellDetails.subject !== undefined) {
				cellGradeDetails = cellDetails.subject.gradeDetails
			} else if (cellDetails.elective !== undefined) {
				cellGradeDetails = cellDetails.elective.gradeDetails
			}
			// "EDIT" if numberOfTeachersAndTAsForSubject is already present 
			if (cellDetails.numberOfTeachersAndTAsForSubject !== undefined) {
				//EDITING FOR GROUPS
				if (this.props.filter.showSections === true) {
					let count = 0;
					let index = undefined;
					let cellDetails_numberOfTeachersAndTAsForSubject = cellDetails.numberOfTeachersAndTAsForSubject

					let teachers = numberOfTeachersAndTAsForSubject.teachers
					let TAs = numberOfTeachersAndTAsForSubject.TAs
					let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForSubjects, cellDetails_numberOfTeachersAndTAsForSubject)

					if (objIndex === undefined) {
						objMatching = false
					} else {
						let obj = numberOfTeachersAndTAsForSubjects[objIndex]
						if (obj.teachers === teachers) {
							if (obj.TAs === TAs) {
								objMatching = true;
							}
						}
					}
					if (objMatching === false) {
						// remove obj code 
						for (let d = 0; d < numberOfTeachersAndTAsForSubjects.length; d++) {
							let gradeObj = numberOfTeachersAndTAsForSubjects[d].gradeDetails.grades[0]
							if ((cellDetails.subject && cellDetails.subject._id == numberOfTeachersAndTAsForSubjects[d].subjectId)) {
								if (gradeObj.grade === cellDetails.grade) {
									count++
									if (gradeObj.groups.length === 0) {
										index = d;
									}

								}
							}
						}
						// SPLICE
						let subGradeObj;
						let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
						if (isLevelPresent !== undefined) {
							let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
							if (gradeLevelObj !== undefined)
								subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
						} else {
							subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
						}
						// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
						if (cellGradeDetails.allGrades === true
							|| cellGradeDetails.gradeLevel.length !== 0
							|| subGradeObj.groups.length === 0) {
							for (let p = 0; p < gradeLevels.length; p++) {
								let gradeLevel = gradeLevels[p]
								let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
								if (selectedObj !== undefined) {
									if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
										numberOfTeachersAndTAsForSubjects.splice(index, 1);
										break;
									}
								}
							}
						}
						// SUBJECT is there only for SOME GROUPS in that grade.
						else {
							if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
								numberOfTeachersAndTAsForSubjects.splice(index, 1);
							}
						}
					}

					// REPLACING the object for GROUPS
					let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForSubjects, cellDetails_numberOfTeachersAndTAsForSubject)
					if (objectIndex !== undefined) {
						numberOfTeachersAndTAsForSubjects[objectIndex].teachers = numberOfTeachersAndTAsForSubject.teachers
						numberOfTeachersAndTAsForSubjects[objectIndex].TAs = numberOfTeachersAndTAsForSubject.TAs
						numberOfTeachersAndTAsForSubjects[objectIndex].showNumberOfTeachersForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTeachersForSubjectString
						numberOfTeachersAndTAsForSubjects[objectIndex].showNumberOfTAsForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTAsForSubjectString
					}
				}
				//"GRADES" show sections is false so we are clicking on grades which already has the data 
				else {
					let cellDetails_numberOfTeachersAndTAsForSubject = cellDetails.numberOfTeachersAndTAsForSubject
					let teachers = numberOfTeachersAndTAsForSubject.teachers
					let TAs = numberOfTeachersAndTAsForSubject.TAs
					let objMatching = false;
					let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForSubjects, cellDetails_numberOfTeachersAndTAsForSubject)
					if (objIndex === undefined) {
						objMatching = false
					} else {
						let obj = numberOfTeachersAndTAsForSubjects[objIndex]
						if (obj.teachers === teachers) {
							if (obj.TAs === TAs) {
								objMatching = true;
							}
						}
					}
					if (objMatching === false) {
						//all the groups should eb over ridden with this value
						for (let h = 0; h < numberOfTeachersAndTAsForSubjects.length; h++) {

							if ((cellDetails.subject && cellDetails.subject._id == numberOfTeachersAndTAsForSubjects[h].subjectId)) {
								if (numberOfTeachersAndTAsForSubjects[h].gradeDetails.grades[0].grade === cellDetails.grade) {
									numberOfTeachersAndTAsForSubjects[h].teachers = numberOfTeachersAndTAsForSubject.teachers;
									numberOfTeachersAndTAsForSubjects[h].TAs = numberOfTeachersAndTAsForSubject.TAs;
									numberOfTeachersAndTAsForSubjects[h].showNumberOfTeachersForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTeachersForSubjectString;
									numberOfTeachersAndTAsForSubjects[h].showNumberOfTAsForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTAsForSubjectString;

									if (numberOfTeachersAndTAsForSubjects[h].gradeDetails.grades[0].groups.length != 0) {
										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubjects[h]))
										}
									}
								}

							}
						}
					}
					this.creatingNumberOfTeachersAndTAsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
			}

			//"NEW OBJECT" if numberOfTeachersAndTAsForSubject is not present in the schedule constraint
			else {
				// if the selected cell is for the grade and not for groups
				if (cellDetails.group === undefined) {
					//grade's object from master
					for (let g = 0; g < gradeLevels.length; g++) {
						let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
						//GRADE (groups is empty)
						if (gradeObj !== undefined) {
							let numberOfTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubject))
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [{
									level: cellDetails.gradeLevel
								}],
								grades: [{
									grade: cellDetails.grade,
									groups: [],
								}],
							}
							numberOfTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects.push(numberOfTeachersAndTAsForSubjectObj);

							let existingGroupArray = [];

							for (let x = 0; x < numberOfTeachersAndTAsForSubjects.length; x++) {

								if ((cellDetails.subject && cellDetails.subject._id == numberOfTeachersAndTAsForSubjects[x].subjectId)) {
									if (numberOfTeachersAndTAsForSubjects[x].gradeDetails.grades[0].grade === cellDetails.grade
										&& numberOfTeachersAndTAsForSubjects[x].gradeDetails.grades[0].groups.length > 0) {

										existingGroupArray.push(numberOfTeachersAndTAsForSubjects[x].gradeDetails.grades[0].groups[0].groupCode)
										numberOfTeachersAndTAsForSubjects[x].teachers = numberOfTeachersAndTAsForSubject.teachers;
										numberOfTeachersAndTAsForSubjects[x].TAs = numberOfTeachersAndTAsForSubject.TAs;
										numberOfTeachersAndTAsForSubjects[x].showNumberOfTeachersForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTeachersForSubjectString;
										numberOfTeachersAndTAsForSubjects[x].showNumberOfTAsForSubjectString = numberOfTeachersAndTAsForSubject.showNumberOfTAsForSubjectString;

										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubjects[x]))
										}

									}
								}
							}
							// to create NEW data to all the groups  
							//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
							let commonGradeObj;
							let cellGrade
							let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
							if (isLevelPresent !== undefined) {
								let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
								if (gradeLevelObj !== undefined)
									cellGrade = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);

							} else {
								cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
							}
							let gradeObj = undefined
							for (let t = 0; gradeLevels.length; t++) {
								let gradeLevel = gradeLevels[t];
								if (gradeLevel.levelName === cellDetails.gradeLevel) {
									gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
								}
								if (gradeObj !== undefined) {
									break;
								}
							}
							if (cellGradeDetails !== undefined) {
								commonGradeObj = gradeObj;
							}

							for (let m = 0; m < commonGradeObj.groups.length; m++) {
								// AFTER GRADE => GROUPS
								if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
									let numberOfTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubject));
									let gradeDetails = {
										allGrades: false,
										gradeLevels: [{
											level: cellDetails.gradeLevel
										}],
										grades: [{
											grade: cellDetails.grade,
											groups: [{
												groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
											}],
										}],
									}
									numberOfTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
									tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects.push(numberOfTeachersAndTAsForSubjectObj)

									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubjectObj))
									}
								}
							}
							break;
						}
					}
					this.creatingNumberOfTeachersAndTAsForSubjectsObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
				// selected cell for GROUPS
				else {
					let numberOfTeachersAndTAsForSubjectObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForSubject));
					let gradeDetails = {
						allGrades: false,
						gradeLevels: [{
							level: cellDetails.gradeLevel
						}],
						grades: [{
							grade: cellDetails.grade,
							groups: [
								{ groupCode: cellDetails.group }
							],
						}],
					}
					numberOfTeachersAndTAsForSubjectObj.gradeDetails = gradeDetails;
					if (cellDetails.jointClass !== undefined) {
						numberOfTeachersAndTAsForSubjectObj.jointClassId = cellDetails.jointClass._id
					}
					numberOfTeachersAndTAsForSubjects.push(numberOfTeachersAndTAsForSubjectObj)
				}
			}
		}
		tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
			ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_SUBJECTS)

		await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
		this.attachingDataToCellForSubjects();
		this.props.handleCloseForDialog();
		this.props.handleClose();
	}

	creatingNumberOfTeachersAndTAsForSubjectsObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let numberOfTeachersAndTAsForSubjectsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForSubjects

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if (cellDetails.subject && cellDetails.subject._id == jointClassObj.subjectId) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//NUMBER OF TEACHERS AND TAS FOR SUBJECT FROM DATABASE
							for (let d = 0; d < numberOfTeachersAndTAsForSubjectsArray.length; d++) {
								let numberOfTeachersAndTAsForSubjectObj = numberOfTeachersAndTAsForSubjectsArray[d];
								let numberOfTeachersAndTAsForSubjectObj_grades = numberOfTeachersAndTAsForSubjectObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (numberOfTeachersAndTAsForSubjectObj_grades.grade === gradeObj.grade
									&& numberOfTeachersAndTAsForSubjectObj_grades.groups != undefined
									&& numberOfTeachersAndTAsForSubjectObj_grades.groups.length > 0
									&& numberOfTeachersAndTAsForSubjectObj_grades.groups[0].groupCode === groupObj.groupCode) {

									numberOfTeachersAndTAsForSubjectObj.teachers = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.teachers))
									numberOfTeachersAndTAsForSubjectObj.TAs = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.TAs))
									numberOfTeachersAndTAsForSubjectObj.showNumberOfTeachersForSubjectString = templetObjForCreatingNewObj.showNumberOfTeachersForSubjectString
									numberOfTeachersAndTAsForSubjectObj.showNumberOfTAsForSubjectString = templetObjForCreatingNewObj.showNumberOfTAsForSubjectString
									numberOfTeachersAndTAsForSubjectObj.jointClassId = jointClassObj._id
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								tempObj.jointClassId = jointClassObj._id
								numberOfTeachersAndTAsForSubjectsArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}

	onClickOfSaveForElectives = async () => {
		let tempActiveSchool = this.state.tempActiveSchool;
		let keys = this.props.keys;
		let cellDetails = undefined;
		let gradeLevels = this.props.activeSchool.school_master.gradeLevels
		let objMatching = false;
		let templetObjForCreatingNewObj = undefined;
		let numberOfTeachersAndTAsForElectives = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives
		let numberOfTeachersAndTAsForElective = JSON.parse(JSON.stringify(this.state.numberOfTeachersAndTAsForElective))
		for (let c = 0; c < numberOfTeachersAndTAsForElective.teachersAndTAs.length; c++) {
			let teachersAndTAsObj = numberOfTeachersAndTAsForElective.teachersAndTAs[c];
			teachersAndTAsObj.showNumberOfTeachersForSubjectString = teachersAndTAsObj.teachers.toString();
			teachersAndTAsObj.showNumberOfTAsForSubjectString = teachersAndTAsObj.TAs.toString();
		}
		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			tempActiveSchool.schedule_constraints = [
				{ numberOfTeachersAndTAsForElectives: [] }
			]
		}

		//KEYS 
		for (let c = 0; c < keys.length; c++) {
			cellDetails = this.props.dataTableMap.get(keys[c]);
			// gradeDetails from subject or elective 
			let cellGradeDetails = undefined;
			if (cellDetails.elective !== undefined) {
				cellGradeDetails = cellDetails.elective.gradeDetails
			}

			// "EDIT" if numberOfTeachersAndTAsForElective is already present 
			if (cellDetails.numberOfTeachersAndTAsForElective !== undefined) {
				//EDITING FOR GROUPS
				if (this.props.filter.showSections === true) {
					let count = 0;
					let index = undefined;
					let cellDetails_numberOfTeachersAndTAsForElective = cellDetails.numberOfTeachersAndTAsForElective
					let teachersAndTAs = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective.teachersAndTAs))

					// COMPARE TWO ARRAY TO FIND IF THE VALUES HAVE BEEN CHANGED IN 2 PLACES 
					let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForElectives, cellDetails_numberOfTeachersAndTAsForElective)

					if (objIndex === undefined) {
						objMatching = false
					} else {
						let obj = numberOfTeachersAndTAsForElectives[objIndex]
						for (let k = 0; k < teachersAndTAs.length; k++) {
							if (obj.teachersAndTAs[k].teachers === teachersAndTAs[k].teachers) {
								if (obj.teachersAndTAs[k].TAs === teachersAndTAs[k].TAs) {
									objMatching = true;
								} else {
									objMatching = false;
									break;
								}
							} else {
								objMatching = false;
								break;
							}
						}
					}

					if (objMatching === false) {
						for (let d = 0; d < numberOfTeachersAndTAsForElectives.length; d++) {
							let gradeObj = numberOfTeachersAndTAsForElectives[d].gradeDetails.grades[0]
							if ((cellDetails.elective && cellDetails.elective._id == numberOfTeachersAndTAsForElectives[d].electiveId)) {
								if (gradeObj.grade === cellDetails.grade) {
									count++
									if (gradeObj.groups.length === 0) {
										index = d;
									}

								}
							}
						}
						// SPLICE
						let subGradeObj;
						let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
						if (isLevelPresent !== undefined) {
							let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
							if (gradeLevelObj !== undefined) {
								subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
							}
						} else {
							subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
						}
						// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
						if (cellGradeDetails.allGrades === true
							|| cellGradeDetails.gradeLevel !== 0
							|| subGradeObj.groups.length === 0) {
							for (let p = 0; p < gradeLevels.length; p++) {
								let gradeLevel = gradeLevels[p]
								let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
								if (selectedObj !== undefined) {
									if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
										numberOfTeachersAndTAsForElectives.splice(index, 1);
										break;
									}
								}
							}
						}
						// SUBJECT is there only for SOME GROUPS in that grade.
						else {
							if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
								numberOfTeachersAndTAsForElectives.splice(index, 1);
							}
						}

						// GROUPS REPLACING 
						let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForElectives, cellDetails_numberOfTeachersAndTAsForElective)
						if (objectIndex !== undefined) {
							numberOfTeachersAndTAsForElectives[objectIndex].teachersAndTAs = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective.teachersAndTAs))
						}
					}
					//if user has not changed the data and clicked on save 
					else {
						// continue with the next key withought saving 
						continue;
					}


				}
				//"GRADES" show sections is false so we are clicking on grades which already has the data 
				else {
					let cellDetails_numberOfTeachersAndTAsForElective = cellDetails.numberOfTeachersAndTAsForElective
					let teachersAndTAs = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective.teachersAndTAs))
					let objMatching = false;

					// COMPARE TWO ARRAY TO FIND IF THE VALUES HAVE BEEN CHANGED IN 2 PLACES 
					let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(numberOfTeachersAndTAsForElectives, cellDetails_numberOfTeachersAndTAsForElective)

					if (objIndex === undefined) {
						objMatching = false
					} else {
						let obj = numberOfTeachersAndTAsForElectives[objIndex]
						for (let k = 0; k < teachersAndTAs.length; k++) {
							if (obj.teachersAndTAs[k].teachers === teachersAndTAs[k].teachers) {
								if (obj.teachersAndTAs[k].TAs === teachersAndTAs[k].TAs) {
									objMatching = true;
								} else {
									objMatching = false;
									break;
								}
							} else {
								objMatching = false;
								break;
							}
						}
					}

					if (objMatching === false) {
						//all the groups should eb over ridden with this value
						for (let h = 0; h < numberOfTeachersAndTAsForElectives.length; h++) {

							if ((cellDetails.elective && cellDetails.elective._id == numberOfTeachersAndTAsForElectives[h].electiveId)) {
								if (numberOfTeachersAndTAsForElectives[h].gradeDetails.grades[0].grade === cellDetails.grade) {
									numberOfTeachersAndTAsForElectives[h].teachersAndTAs = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective.teachersAndTAs))

									if (numberOfTeachersAndTAsForElectives[h].gradeDetails.grades[0].groups.length != 0) {
										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElectives[h]))
										}
									}
								}

							}
						}
					} else {
						continue;
					}
					this.creatingNumberOfTeachersAndTAsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
			}

			//"NEW OBJECT" if obj is not present in the schedule constraint
			else {
				// if the selected cell is for the grade and not for groups
				if (cellDetails.group === undefined) {
					//grade's object from master
					for (let g = 0; g < gradeLevels.length; g++) {
						let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
						//GRADE (groups is empty)
						if (gradeObj !== undefined) {
							let numberOfTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective))
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [{
									level: cellDetails.gradeLevel
								}],
								grades: [{
									grade: cellDetails.grade,
									groups: [],
								}],
							}
							numberOfTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails;
							tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives.push(numberOfTeachersAndTAsForElectiveObj);

							let existingGroupArray = [];
							for (let x = 0; x < numberOfTeachersAndTAsForElectives.length; x++) {
								if ((cellDetails.elective && cellDetails.elective._id == numberOfTeachersAndTAsForElectives[x].electiveId)) {
									if (numberOfTeachersAndTAsForElectives[x].gradeDetails.grades[0].grade === cellDetails.grade && numberOfTeachersAndTAsForElectives[x].gradeDetails.grades[0].groups.length > 0) {
										existingGroupArray.push(numberOfTeachersAndTAsForElectives[x].gradeDetails.grades[0].groups[0].groupCode)
										numberOfTeachersAndTAsForElectives[x].teachersAndTAs = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective.teachersAndTAs))

										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElectives[x]))
										}
									}
								}
							}
							// to create NEW data to all the groups  
							//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
							let commonGradeObj;
							let cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
							let gradeObj = undefined
							for (let t = 0; gradeLevels.length; t++) {
								let gradeLevel = gradeLevels[t];
								gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
								if (gradeObj !== undefined) {
									break;
								}
							}
							if (cellGradeDetails !== undefined) {
								commonGradeObj = gradeObj;
							}
							for (let m = 0; m < commonGradeObj.groups.length; m++) {
								// AFTER GRADE => GROUPS
								if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
									let numberOfTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective))
									let gradeDetails = {
										allGrades: false,
										gradeLevels: [{
											level: cellDetails.gradeLevel
										}],
										grades: [{
											grade: cellDetails.grade,
											groups: [{
												groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
											}],
										}],
									}
									numberOfTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails;
									tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives.push(numberOfTeachersAndTAsForElectiveObj);

									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElectiveObj))
									}
								}
							}
							break;
						}
					}
					this.creatingNumberOfTeachersAndTAsForElectivesObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
				}
				// selected cell for GROUPS
				else {
					let numberOfTeachersAndTAsForElectiveObj = JSON.parse(JSON.stringify(numberOfTeachersAndTAsForElective))
					let gradeDetails = {
						allGrades: false,
						gradeLevels: [{
							level: cellDetails.gradeLevel
						}],
						grades: [{
							grade: cellDetails.grade,
							groups: [
								{ groupCode: cellDetails.group }
							],
						}],
					}
					numberOfTeachersAndTAsForElectiveObj.gradeDetails = gradeDetails;
					if (cellDetails.jointClass !== undefined) {
						numberOfTeachersAndTAsForElectiveObj.jointClassId = cellDetails.jointClass._id
					}
					numberOfTeachersAndTAsForElectives.push(numberOfTeachersAndTAsForElectiveObj);
				}
			}
		}
		tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
			ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_ELECTIVES)

		await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
		this.attachingDataToCellForElective();
		this.props.handleCloseForDialog();
		this.props.handleClose();
	}

	creatingNumberOfTeachersAndTAsForElectivesObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let numberOfTeachersAndTAsForElectivesArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].numberOfTeachersAndTAsForElectives

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if (cellDetails.elective && cellDetails.elective._id == jointClassObj.electiveId) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//NUMBER OF TEACHERS AND TAS FOR ELECTIVES FROM DATABASE
							for (let d = 0; d < numberOfTeachersAndTAsForElectivesArray.length; d++) {
								let numberOfTeachersAndTAsForElectiveObj = numberOfTeachersAndTAsForElectivesArray[d];
								let numberOfTeachersAndTAsForElectiveObj_grades = numberOfTeachersAndTAsForElectiveObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (numberOfTeachersAndTAsForElectiveObj_grades.grade === gradeObj.grade
									&& numberOfTeachersAndTAsForElectiveObj_grades.groups != undefined
									&& numberOfTeachersAndTAsForElectiveObj_grades.groups.length > 0
									&& numberOfTeachersAndTAsForElectiveObj_grades.groups[0].groupCode === groupObj.groupCode) {

									numberOfTeachersAndTAsForElectiveObj.teachersAndTAs = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.teachersAndTAs))
									numberOfTeachersAndTAsForElectiveObj.jointClassId = jointClassObj._id
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								delete tempObj.gradeDetails.grades[0].grade._id;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								delete tempObj.gradeDetails.grades[0].groups[0]._id;
								tempObj.jointClassId = jointClassObj._id
								numberOfTeachersAndTAsForElectivesArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.state.isElective === false ?
					<TeacherAndTAsComponent
						{...this.props}
						{...this.state}
						handleChange={this.handleChange}
						onClickOfSave={this.onClickOfSave}
						getNumberOfTeachersAndTAs={this.getNumberOfTeachersAndTAs}
					/> :
					<ElectiveTeachersAndTAsComponent
						{...this.props}
						{...this.state}
						elective={this.state.elective}
						handleChangeForElective={this.handleChangeForElective}
						onClickOfSave={this.onClickOfSave}
						getNumberOfTeachersAndTAs={this.getNumberOfTeachersAndTAs}

					/>}
			</React.Fragment>
		)
	}
}

const mapStateToProps = (state) => ({
	activeScheduleIndex: state.schoolInformation.activeScheduleIndex,
	updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
});

const mapDispatchToProps = (dispatch) => ({
});

// export default connect(mapStateToProps, mapDispatchToProps)(TeacherAndTAsContainer)
export default connect(mapStateToProps, mapDispatchToProps)(TeacherAndTAsContainer)

